import getTrendLineChartDataApi from '../apis';

const getTrendLineChartData = async ({ cohort }) => {
  try {
    const res = await getTrendLineChartDataApi({
      cohort,
    });
    const data = res?.entity;
    return data;
  } catch (error) {
    console.error('Error fetching review insights chart data : ', error);
  }

  return null;
};

export default getTrendLineChartData;
